/* eslint-disable no-unused-vars */
export type FontWeight = 'light' | 'normal' | 'medium' | 'semibold' | 'bold';
export enum Sizes {
  lg = 'lg',
  md = 'md',
  reg = 'reg',
  sm = 'sm',
}

export const options = [
  { name: 'United States', value: 'United States' },
  { name: 'Afghanistan', value: 'Afghanistan' },
  { name: 'Albania', value: 'Albania' },
  { name: 'Algeria', value: 'Algeria' },
];
